<template>
  <div>
    <Heade>
      <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push('/')"></template>
      <template v-slot:title>直播回看</template>
    </Heade>
    <div v-if="isShow">
      <div class="container"  v-for="(item,index) in List" :key="index" >
          <div class="base" @click='openVideo(item.meeting_field,item.id,item.video_id)'>
              <div class="myImg">
                  <img :src="item.video_cover_url" alt="">
                  <div class="title">急先锋-{{item.meeting_name}}</div>
              </div>
              <div class="content">
                  <div class="content_top"><span>会议时间：</span>{{item.meeting_time}}</div>
                  <div class="content_dow">
                      <div class="title">参会专家：</div>
                      <div class="expertList">
                          <div class="name" v-for="(it,i) in item.professerList" :key="i">{{it.professor_name}}-{{it.professor_company}}</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div class="none" v-if="!isShow">
      <img src="../../assets/img/空.png" alt="">
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      List: [],
      isShow: false
    };
  },
  //接收来自父组件的数据
  props: {},
  //生命周期实例创建完成后被立即调用
  created() {},
  //生命周期挂载完成之后被调用
  mounted() {
    this.getList();
  },
  //组件
  components: {},
  //方法
  methods: {
    openVideo(meeting_field, id, video_id) {
      console.log(meeting_field, id, video_id);
      this.$router.push({
        path:'/Vedio',
        query:{
          meeting_field:meeting_field,
          id:id,
          video_id:video_id
        }
      });
      //  window.location.href="./video.html?meeting_field="+meeting_field+"&id="+id+"&video_id="+video_id;
    },
    //获取列表
    getList() {
      const url = "/api/videoRecord/appList";
      this.axios.post(url,{meetingType:2}).then(res => {
        console.log(res);
        if (res.data.code === "00000") {
          const data = res.data.model;
          if (data.length > 0) {
            this.isShow = true;
            this.List = res.data.model;
          } else {
            this.isShow = false;
          }

          console.log(this.List);
        }
      });
    }
  },
  //监视
  watch: {}
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 30px;
  .base {
    width: 100%;
    border-radius: 20px;
    background: #ffffff;
    .myImg {
      width: 100%;
      height: 388px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 20px 20px 0px 0;
      }
      .title {
        min-width: 100%;
        max-width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        line-height: 60px;
        background-color: #004d7d;
        box-sizing: border-box;
        padding: 0 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .content {
      font-size: 24px;
      color: #999;
      box-sizing: border-box;
      padding: 30px;
      .content_top {
        margin-bottom: 16px;
      }
      .content_dow {
        display: flex;
        .title {
          color: #333;
        }
        .expertList {
          .name {
            margin-bottom: 8px;
          }
        }
      }
      span {
        color: #333;
      }
    }
  }
}
.none {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-top: 160px;
    width: 530px;
    height: 440px;
  }
}
</style>